const deliverables = [
  {
    icon: 'ri-robot-2-line',
    title: 'Ваш полностью обученный ИИ-аватар',
    text: 'Цифровой клон с вашей внешностью, мимикой и жестами, готовый генерировать видео 24/7.',
  },
  {
    icon: 'ri-mic-2-line',
    title: 'Клонированный голос',
    text: 'Голос, который звучит как вы — с вашими уникальными интонациями и тембром.',
  },
  {
    icon: 'ri-film-line',
    title: 'Комплект первых готовых видео',
    text: 'Reels или обучающий ролик — уже на выходе, готовы к публикации.',
  },
];

export default function AIAvatarDeliverables() {
  return (
    <section className="py-14 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10 sm:mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#1A2B4C]/08 border border-[#1A2B4C]/15 mb-5">
            <i className="ri-gift-line text-[#C5A880] text-sm"></i>
            <span className="text-[#1A2B4C] text-xs font-bold font-['Montserrat'] uppercase tracking-widest">
              Что входит в пакет
            </span>
          </div>
          <h2 className="text-xl sm:text-4xl font-['Playfair_Display'] font-bold text-[#1A2B4C] mb-4 leading-tight">
            Что вы получаете на выходе
          </h2>
          <div className="w-16 h-1 bg-[#C5A880] mx-auto rounded-full"></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-8">
          {deliverables.map((d, i) => (
            <div key={d.title} className="relative bg-[#F9F5EF] rounded-2xl p-5 sm:p-8 border border-[#E8DDD0] hover:border-[#C5A880] transition-colors duration-300">
              <div className="absolute top-4 right-5 text-5xl sm:text-6xl font-extrabold text-[#1A2B4C]/04 font-['Playfair_Display'] select-none leading-none">
                {String(i + 1).padStart(2, '0')}
              </div>
              <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center rounded-xl bg-[#1A2B4C] mb-4 sm:mb-5">
                <i className={`${d.icon} text-xl sm:text-2xl text-[#C5A880]`}></i>
              </div>
              <h3 className="text-sm sm:text-lg font-bold text-[#1A2B4C] font-['Playfair_Display'] mb-2 sm:mb-3 leading-snug">
                {d.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed font-['Montserrat'] text-justify">
                {d.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
